export default __webpack_public_path__ + "fill-1.png";